import { useState } from "react";
import { X } from "react-feather";
import { useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import YouTubePlayer from "react-youtube";

import TranscriptBox from "./Components/TranscriptBox";
import { updateTranscriptModalState } from "../Actions";
import { GET_VIDEO_DETAILS } from "../../../Queries/ask-vyrill";
import "./VideoPopup.scss";
import { Link } from "react-router-dom";
import TikTokPlayer from "../../TikTokPlayer";
import {
  handleDownloadVideo,
  updateVideoDetailBreadcrumb,
} from "../../../Pages/Video/VideoActions";
import Loader from "../../Loader";
import { DownloadDisableIcon, DownloadIcon } from "../../SVGs/Download";
import { mimeTypes } from "../../../constants";
import { InstagramEmbed } from "react-social-media-embed";

const VideoTranscriptModal = () => {
  const [shouldTranscriptRender, setShouldTranscriptRender] = useState(true);
  const [openDownloadInfo, setOpenDownloadInfo] = useState(false);
  const [videoDownloading, setVideoDownloading] = useState(false);

  const shouldOpen = useSelector(
    (state) => state.modalsState?.videoTranscript?.shouldOpen
  );
  const videoId = useSelector(
    (state) => state.modalsState?.videoTranscript?.videoId
  );

  const videoStartAt = useSelector(
    (state) => state.modalsState?.videoTranscript?.videoStartAt
  );

  const video = useSelector(
    (state) => state.videoAssociations.body.video || {}
  );

  const dispatch = useDispatch();
  const {
    loading,
    error,
    data: videoData,
  } = useQuery(GET_VIDEO_DETAILS, {
    variables: { _id: videoId },
    skip: !videoId,
  });

  const style = {
    width: "40px",
    position: "absolute",
    top: "6%",
    left: "3.3%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
  };
  const GoogleDriveImg = (
    <img
      src={
        require(`@src/assets/images/vyrill/icons/google_drive_icon.png`).default
      }
      style={style}
    />
  );
  const GenerateIcon = ({ path }) => {
    return (
      <img
        src={require(`@src/assets/images/vyrill/videos/${path}`).default}
        style={style}
      />
    );
  };
  const downloadVideo = () => {
    if (videoDownloading) {
      return null;
    }
    setVideoDownloading(true);
    handleDownloadVideo(videoData?.getVideo?._id)
      .then(({ data }) => {
        if (data?.signedUrl) {
          fetch(data?.signedUrl)
            .then((response) => response.blob())
            .then((blob) => URL.createObjectURL(blob))
            .then((url) => {
              const link = document.createElement("a");
              link.href = url;
              link.download = `${videoData?.getVideo?.title || "download"}`;
              link.setAttribute("type", "hidden");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              // For Firefox it is necessary to delay revoking the ObjectURL
              setTimeout(() => {
                URL.revokeObjectURL(data?.signedUrl);
              }, 100);
              setVideoDownloading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setVideoDownloading(false);
      });
  };

  const videosPageBreadcrumb = [
    {
      name: "Home",
      type: "link",
      link: "/home",
      page: "videos",
    },
  ];

  return (
    <Modal
      className="modal-dialog-centered video-popup-model"
      size="lg"
      isOpen={shouldOpen}
      toggle={() => dispatch(updateTranscriptModalState({ shouldOpen: false }))}
      role=""
      style={{ maxWidth: "1058px" }}
    >
      <ModalHeader className="justify-content-end cross-close">
        <X
          size={30}
          role="button"
          strokeWidth="1"
          onClick={() =>
            dispatch(updateTranscriptModalState({ shouldOpen: false }))
          }
        />
      </ModalHeader>
      <ModalBody>
        <div className="video-popup-header">
          <div className="video-popup-title">{videoData?.getVideo?.title}</div>

          {openDownloadInfo && (
            <p className="downlaod-tooltip download-icon">
              {videoData?.getVideo?.platform === "Vyrill_AWS_S3" ||
              videoData?.getVideo?.platform === "GoogleDrive"
                ? `${videoDownloading ? "Downloading" : "Download"} Video`
                : "Downloading YouTube and TikTok video is not supported"}
            </p>
          )}

          <span
            onMouseOver={() => setOpenDownloadInfo(true)}
            onMouseOut={() => setOpenDownloadInfo(false)}
          >
            {(videoData?.getVideo?.platform === "Vyrill_AWS_S3" ||
              videoData?.getVideo?.platform === "GoogleDrive") && (
              <div className="download-icon" onClick={downloadVideo}>
                {videoDownloading ? <Loader /> : <DownloadIcon />}
              </div>
            )}

            {(videoData?.getVideo?.platform === "Youtube" ||
              videoData?.getVideo?.platform === "Tiktok") && (
              <div className="download-icon">{<DownloadDisableIcon />}</div>
            )}
          </span>

          <div>
            <Link to={`/videos/${videoId}`}>
              <Button
                color="outline-primary"
                variant="outlined"
                onClick={() => {
                  dispatch(updateTranscriptModalState({ shouldOpen: false }));
                  dispatch(updateVideoDetailBreadcrumb(videosPageBreadcrumb));
                }}
              >
                See Video Analysis
              </Button>
            </Link>
          </div>
        </div>
        <div>
          {/* Handling platforms players */}
          {videoData?.getVideo?.platform === "GoogleDrive" &&
            videoData?.getVideo?.video_url && (
              <>
                {videoData.getVideo.video_url.includes("denali") ? (
                  <div
                    className="videoWrapper"
                    style={{ minHeight: "378px", position: "relative" }}
                  >
                    {GoogleDriveImg}
                    <video
                      id="video"
                      className="videoFrame"
                      height="530"
                      width="942"
                      style={{
                        minHeight: "378px",
                        background: "black",
                      }}
                      controls
                      autoPlay
                    >
                      <source
                        src={`${videoData.getVideo.video_url}#t=${videoStartAt}`}
                        type={
                          mimeTypes[
                            videoData.getVideo.title?.split(".")?.pop()
                          ] || ""
                        }
                      />
                      <p>
                        Sorry, your browser doesn&apos;t support embedded
                        videos.
                      </p>
                    </video>
                  </div>
                ) : (
                  <div style={{ position: "relative" }}>
                    {GoogleDriveImg}
                    <iframe
                      src={`${videoData.getVideo.video_url.replace(
                        "view",
                        "preview"
                      )}&t=${videoStartAt}s`}
                      height="530"
                      width="942"
                      sandbox="allow-scripts allow-same-origin"
                      allow="autoPlay"
                      allowFullScreen={true}
                      id="video"
                    ></iframe>
                  </div>
                )}
              </>
            )}
          {videoData?.getVideo?.video_embedded_url &&
            videoData?.getVideo?.platform === "Youtube" && (
              <div style={{ position: "relative" }}>
                {GenerateIcon({ path: "youtubeIcon.png" })}
                <YouTubePlayer
                  videoId={
                    videoData?.getVideo?.video_embedded_url &&
                    videoData?.getVideo?.video_embedded_url.match(
                      /embed\/(.*)/
                    )[1]
                  }
                  opts={{
                    height: "530",
                    width: "942",
                    playerVars: {
                      autoplay: 1,
                      start: videoStartAt,
                    },
                  }}
                />
              </div>
            )}
          {videoData?.getVideo?.video_url &&
            videoData?.getVideo?.platform === "Tiktok" && (
              <>
                <div className="tiktok-icon">
                  {GenerateIcon({ path: "tikTokIcon.png" })}
                </div>
                <TikTokPlayer video={videoData?.getVideo} />
              </>
            )}
          {videoData?.getVideo?.video_url &&
            videoData?.getVideo?.platform === "Instagram" && (
              <>
                <img
                  src={
                    require(`@src/assets/images/vyrill/reports/instagram_icon.png`)
                      .default
                  }
                  className="instagram-icon"
                />
                <div className="d-flex justify-content-center">
                  <InstagramEmbed
                    url={videoData?.getVideo?.video_url}
                    linkText="Loading..."
                    height={564}
                    width={428}
                  />
                </div>
              </>
            )}
          {(videoData?.getVideo?.platform === "Vyrill_AWS_S3" ||
            videoData?.getVideo?.platform === "AWS_S3_Swirl") &&
            videoData?.getVideo?.video_url && (
              <div className="videoWrapper">
                <video
                  id={`S3-${videoData?.getVideo?._id}`}
                  className="videoFrame"
                  width="97%"
                  autoPlay={true}
                  height="auto"
                  controls={true}
                  onLoadedMetadata={(e) => {
                    e.target.currentTime = videoStartAt;
                  }}
                >
                  <source src={videoData?.getVideo?.video_url} />
                </video>
              </div>
            )}

          {videoData?.getVideo?.video_url &&
            videoData?.getVideo?.platform === "Dropbox" && (
              <div style={{ position: "relative" }}>
                {GenerateIcon({ path: "dropboxIcon.png" })}
                <div className="videoWrapper">
                  <video
                    id="video"
                    className="videoFrame"
                    width="100%"
                    height="auto"
                    autoPlay
                    controls={true}
                  >
                    <source
                      src={`${videoData?.getVideo?.video_url.replace(
                        "www.dropbox.com",
                        "dl.dropboxusercontent.com"
                      )}#t=${videoStartAt}`}
                      type={
                        mimeTypes[videoData?.getVideo.title.split(".").pop()] ||
                        ""
                      }
                    />
                    <p>Sorry, your browser doesn't support embedded videos.</p>
                  </video>
                </div>
              </div>
            )}
        </div>
        <TranscriptBox
          setShouldTranscriptRender={setShouldTranscriptRender}
          shouldTranscriptRender={shouldTranscriptRender}
        />
      </ModalBody>
    </Modal>
  );
};

export default VideoTranscriptModal;
